'use client'

import { InternalServerErrorPage } from '@/feature/error/pages/internal-server-error-page/InternalServerErrorPage.client'

export default function RootErrorPage({ error }: { error: Error }) {
  return <InternalServerErrorPage error={error} />
}
